<template>
  <div
    v-if="block?.mobileImage && block?.desktopImage"
    class="ad-block"
  >
    <div class="ad-block__container container">
      <div class="ad-block__content">
        <div
          v-if="block.title"
          class="
            ad-block__title
            text-body-m-bold
            text-heading-xl-desktop
          "
          v-text="block.title"
        />

        <transition-height>
          <div
            v-show="isExpanded"
            class="ad-block__paragraph text-body-xxs-regular text-body-s-regular-desktop"
            v-text="block.paragraph"
          />
        </transition-height>

        <div
          v-if="block.paragraph"
          class="ad-block__read-more text-body-xxs-bold text-body-s-bold-desktop"
          @click="isExpanded = !isExpanded"
        >
          {{ isExpanded ? $string('general.read_less') : $string('general.read_more') }}
        </div>
      </div>

      <div class="ad-block__overlay"></div>

      <div
        v-if="block.mobileImage || block.desktopImage"
        class="ad-block__image"
      >
        <responsive-image
          v-if="isMobile"
          :padding="false"
          :image="block.mobileImage"
        />

        <responsive-image
          v-if="!isMobile"
          :padding="false"
          :image="block.desktopImage"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Ad Block (ad-block)
 * -----------------------------------------------------------------------------
 *
 * @param {Object} block - Section block
 *
 */
import ResponsiveImage from '~global/images/responsive-image'
import TransitionHeight from '~async/transition-height/transition-height'
import { mapState } from 'vuex'

export default {
  name: 'AdBlock',

  components: {
    ResponsiveImage,
    TransitionHeight,
  },

  props: {
    block: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isExpanded: false,
    }
  },

  computed: {
    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },
}
</script>

<style lang="scss">
@import './ad-block';
</style>
